import { useState } from 'react'
import { Box, Typography, Frame, Button } from 'components'
import { Chip } from '@material-ui/core'
import { useDiversityTags, updateUser, useContent } from "utils";
import { ProgressBarFooter } from '../FreelancerCreate/FreelancerProgressBarFooter'

export default function FreelancerSelfIdentification({ user, onboarding, history, onNext, stepIndex, totalSteps }) {
    const [state, setState] = useState({
        selfIdentificationTags: user.selfIdentificationTags ? user.selfIdentificationTags : [],
    })
    const diversityTags = useDiversityTags()
    const { landing, content, diversityBlurb } = useContent() || {}
    const buttonColor = landing?.['onboarding-button-color'] || 'primary'
    const buttonSecondaryColor = landing?.['onboarding-button-secondary'] || '#6c757d'
    
    // Get diversity blurb from content or use fallback
    // const diversityBlurb = content?.diversityBlurb

    if (!diversityTags)
        return null

    const handleTagClick = (e) => {
        const newTags = [...state.selfIdentificationTags]
        if (newTags.includes(e.target.textContent)) {
            newTags.splice(newTags.indexOf(e.target.textContent), 1)
            setState({ ...state, selfIdentificationTags: newTags })
        } else {
            newTags.push(e.target.textContent)
            setState({ ...state, selfIdentificationTags: newTags })
        }
    }

    const handleSubmit = () => {
        updateUser(user, { selfIdentificationTags: state.selfIdentificationTags })
        if (onboarding) {
            onNext()
        } else {
            history.push("/profile")
        }
    }

    return (
        <Frame maxWidth="sm" user={user}>
            <Box mx="auto" maxWidth={530}>
                <Box flex={1} flexVariant="column center" mb={2.5}>
                    <Typography variant="h4" style={{ fontWeight: '600' }}>
                        Ethnicity
                    </Typography>
                    <Typography variant="subtitle1" color="textSecondary">
                        (optional)
                    </Typography>
                    <Box my={2} />
                    <Typography variant="body1">
                        {diversityBlurb}
                    </Typography>
                    <Box my={2} />
                    <Typography variant="body2" fontWeight="medium">
                        Select all that apply.
                    </Typography>
                </Box>
                <Box my={2} />
                <Box flexVariant="row align-center" flexWrap="wrap">
                    {diversityTags.map((diversityTag, i) => (
                        <Chip variant={
                            state.selfIdentificationTags.includes(diversityTag.name) ? 'default' : 'outlined'
                        }
                            color="primary"
                            style={{ marginRight: 8, marginBottom: 5 }}
                            key={i}
                            label={diversityTag.name}
                            name={diversityTag.name}
                            onClick={handleTagClick}
                        />
                    ))}
                </Box>
                {onboarding && (
                    <Box my={2} flexVariant="row justify-space-evenly">
                        <Button variant="contained" style={{ width: '40%', backgroundColor: buttonSecondaryColor, color: 'white' }} onClick={() => onNext()}>Skip</Button>
                        <Button variant="contained" style={{ width: '40%', backgroundColor: buttonColor }} onClick={() => handleSubmit()}>Save</Button>
                    </Box>
                )}
                {!onboarding && (
                    <Box my={2} flexVariant="row justify-space-evenly">
                        <Button variant="contained" style={{ width: '40%', backgroundColor: buttonColor }} onClick={() => handleSubmit()}>Save</Button>
                        <Button variant="contained" style={{ width: '40%', backgroundColor: buttonSecondaryColor }} onClick={() => history.push('/profile')}>Cancel</Button>
                    </Box>
                )}
            </Box>
            {onboarding && (
                <ProgressBarFooter
                    valid={true}
                    stepIndex={stepIndex}
                    firstStep={stepIndex}
                    numSteps={totalSteps}
                    onNext={() => onNext()}
                    onPrev={() => { }}
                />
            )}
        </Frame>
    )
}
